import React, {
  ChangeEvent, FocusEvent, useEffect, useRef, useState,
} from 'react';
import classNames from 'classnames';
import useValidation from './hooks/useValidationHook';
import InputProps from './props/inputProps';
import styles from './scss/Input.module.scss';
import InputError from './InputError';
import { trackFormInput } from '../../utils/segment/events';
import { PERSONAL_INFO_INPUT_FIELD } from '../../utils/segment/constants';

const EmailInput: React.FunctionComponent<InputProps> = (props: InputProps) => {
  const {
    name,
    type,
    label,
    autoComplete,
    maxLength,
    placeholder,
    value: defaultValue,
    hasMargin,
    errorMessage,
    disabled,
    handleInput,
    focus,
  } = props;

  const {
    isInvalid,
    validationClass,
    handleValidationChange,
    handleValidationBlur,
  } = useValidation();

  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState('');

  const setFocusOnEmailInput = () => inputRef?.current?.focus();

  useEffect(() => {
    if (focus) setFocusOnEmailInput();
  }, [focus, inputRef]);

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    handleValidationChange(name, e.target.value);
  };

  const handleOnBlur = (e: FocusEvent<HTMLInputElement>) => {
    handleValidationBlur(name, e.target.value);
    if (handleInput) {
      const input = { target: { name, value } };
      handleInput(input);
    }
    trackFormInput(PERSONAL_INFO_INPUT_FIELD);
  };

  return (
    <div className={classNames(styles.inputContainer,
      { [styles.inputContainerMargin]: hasMargin })}
    >
      <label htmlFor={name} className={styles.label}>
        {label}
        <input
          name={name}
          className={classNames(styles.input, validationClass)}
          type={type}
          ref={inputRef}
          value={value}
          defaultValue={defaultValue}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          maxLength={maxLength}
          disabled={disabled}
        />
        {isInvalid && <InputError errorMessage={errorMessage} />}
      </label>
    </div>
  );
};

EmailInput.defaultProps = {
  disabled: false,
  focus: false,
  validateOnMount: 'none',
};

export default EmailInput;
